/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import '@ui5/webcomponents-base/dist/features/F6Navigation.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/store';
import { ThemeProvider } from '@ui5/webcomponents-react';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <Provider store={store}>
        <React.StrictMode>
            <ThemeProvider>
                <App />
            </ThemeProvider>
        </React.StrictMode>
    </Provider>
);
